import React, { useEffect, useState } from "react";
import { AlertCircle, Loader2, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";

const ROUTE_TIMEOUT_MS = 15_000;

export function RouteFeedback({ isLoading, isError = false, onRetry, className = "", label }: { isLoading: boolean; isError?: boolean; onRetry: () => void; className?: string; label?: string }) {
  const { t } = useLanguage();
  const [timedOut, setTimedOut] = useState(false);

  useEffect(() => {
    if (!isLoading) {
      setTimedOut(false);
      return;
    }
    const timer = window.setTimeout(() => setTimedOut(true), ROUTE_TIMEOUT_MS);
    return () => window.clearTimeout(timer);
  }, [isLoading]);

  if (isError || timedOut) {
    return <section className={`mx-auto flex min-h-[12rem] max-w-md flex-col items-center justify-center gap-3 px-5 text-center ${className}`} role="alert">
      <AlertCircle className="h-7 w-7 text-red" />
      <h1 className="text-lg font-semibold">{label ? `${t(timedOut ? "route.timeoutTitle" : "route.errorTitle")}: ${label}` : t(timedOut ? "route.timeoutTitle" : "route.errorTitle")}</h1>
      <p className="text-sm text-muted-foreground">{t("route.retryDescription")}</p>
      <Button type="button" className="min-h-11" onClick={onRetry}><RefreshCw className="h-4 w-4" />{t("route.retry")}</Button>
    </section>;
  }

  if (isLoading) {
    return <div className={`flex min-h-[12rem] items-center justify-center ${className}`} role="status" aria-live="polite"><Loader2 className="h-6 w-6 animate-spin text-primary" /><span className="sr-only">{t("route.loading")}</span></div>;
  }

  return null;
}
